export default __webpack_public_path__ + "static/media/icon1.dbcd43b8.svg";